import { render, staticRenderFns } from "./Asign.vue?vue&type=template&id=ace1c4c4"
import script from "./Asign.vue?vue&type=script&lang=js"
export * from "./Asign.vue?vue&type=script&lang=js"
import style0 from "./Asign.vue?vue&type=style&index=0&id=ace1c4c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports